<template>
  <div class="transfer-details" data-test-id="transferDetails">
    <p class="is-size-500" data-test-id="transferSummary">
      {{ summary }}
    </p>
    <p class="is-size-400 mt-16" data-test-id="transferSentTo">
      {{ i18n.t('mywb.transfer.sentTo', { email: props.transfer.customerEmail }) }}
    </p>
    <p class="is-size-400 mt-8" data-test-id="transferStay">
      {{ i18n.t('mywb.transfer.stayUntilAccepted') }}
    </p>
    <p
      v-if="props.showExpiry"
      class="is-size-400 mt-8"
      data-test-id="transferExpiry"
    >
      {{ i18n.t('mywb.transfer.expiresOn', { date: expiryDate }) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/hooks/useI18n.hook'
import type { Transfer } from '@/core/transfer'

interface Props {
  transfer: Transfer
  showExpiry?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showExpiry: false
})

const i18n = useI18n()

const summary = computed(() => {
  const params = {
    installerName: props.transfer.installerName,
    chargerSerial: props.transfer.chargerSerial,
    siteAddress: props.transfer.siteAddress
  }

  const hasName = !!props.transfer.installerName
  const hasAddress = !!props.transfer.siteAddress

  if (hasName && hasAddress) return i18n.t('mywb.transfer.summary', params)
  if (hasAddress) return i18n.t('mywb.transfer.summaryNoName', params)
  if (hasName) return i18n.t('mywb.transfer.summaryNoAddress', params)

  return i18n.t('mywb.transfer.summaryNoNameNoAddress', params)
})

const expiryDate = computed(() => {
  return new Date(props.transfer.expiresAt).toLocaleDateString(i18n.locale.value)
})
</script>
